import { createQueryKeys } from '@lukemorales/query-key-factory';

import type {
  FetchBookingEventByIdArgs,
  FetchBookingEventsArgs,
  FetchLastCancellationPolicyArgs,
  BookingEventActionArgs,
} from '../api/types/bookingEvents.types';

import {
  fetchBookingEventById,
  fetchBookingEvents,
  fetchBookingVipLink,
  fetchLastBookingCancellationPolicy,
} from '../api/bookingEvents.api';

export const bookingEventsQueryKeys = createQueryKeys('bookingEvents', {
  fetchBookingEvents: ({
    clientUserId,
    from,
    includeCancelled,
    organizationId,
    timeZone,
    to,
    trainerUserId,
  }: FetchBookingEventsArgs) => ({
    queryFn: () =>
      fetchBookingEvents({
        clientUserId,
        from,
        includeCancelled,
        organizationId,
        timeZone,
        to,
        trainerUserId,
      }),
    queryKey: [
      organizationId,
      from,
      to,
      trainerUserId,
      clientUserId,
      includeCancelled,
      timeZone,
    ],
  }),
  fetchBookingEventById: ({
    bookingEventId,
    organizationId,
  }: FetchBookingEventByIdArgs) => ({
    queryFn: () => fetchBookingEventById({ bookingEventId, organizationId }),
    queryKey: [organizationId, bookingEventId],
  }),
  // Separate key from the event itself: the link is fetched only when a trainer
  // opens the share action, and it must not ride along with every calendar read.
  fetchBookingVipLink: ({
    bookingEventId,
    organizationId,
  }: BookingEventActionArgs) => ({
    queryFn: () => fetchBookingVipLink({ bookingEventId, organizationId }),
    queryKey: [organizationId, bookingEventId],
  }),
  fetchLastBookingCancellationPolicy: ({
    organizationId,
  }: FetchLastCancellationPolicyArgs) => ({
    queryFn: () => fetchLastBookingCancellationPolicy({ organizationId }),
    queryKey: [organizationId],
  }),
});
